export default __webpack_public_path__ + "images/0xd02a30d33153877bc20e5721ee53dedee0422b2f.png";